import isNil from "lodash/isNil";
import { createSelector } from "reselect";
import * as pageSelectors from "../pages/selectors";
import * as deviceSelectors from "../devices/selectors";
import * as audienceSelectors from "../audiences/selectors";
import { getBoardId } from "./utils";
import { propertyComparator } from "../../helpers/array";

export function getWevoDetailById(entities, wevoId) {
    const { wevos } = entities;
    if (isNil(wevos)) {
        return null;
    }
    const wevo = wevos[wevoId];
    if (!wevo) return null;
    const devices = getDevicesForWevo(entities, wevoId);
    const audiences = getAudiencesForWevo(entities, wevoId);
    const pages = getPagesForWevo(entities, wevoId);

    return {
        ...wevo,
        pages,
        audiences,
        devices
    };
}

export function getDevicesForWevo(entities, wevoId) {
    const { wevos } = entities;
    if (isNil(wevos)) {
        return null;
    }
    const wevo = wevos[wevoId];
    if (!wevo) return null;
    const devices = wevo.devices;
    return devices
        ? devices.reduce((acc, deviceId) => {
              const device = deviceSelectors.getDeviceById(entities, deviceId);
              if (device) {
                  acc.push(device);
              }
              return acc;
          }, [])
        : null;
}

export function getPagesForWevo(entities, wevoId) {
    const wevos = entities.wevos;
    if (isNil(wevos)) {
        return null;
    }

    const wevo = wevos[wevoId];
    if (isNil(wevo)) {
        return null;
    }

    const pages = wevo.pages;
    if (isNil(pages)) {
        return null;
    }

    return pages
        .map(id => pageSelectors.getPageById(entities, id))
        .filter(Boolean)
        .sort(propertyComparator("sortOrder"));
}

export function getAudiencesForWevo(entities, wevoId) {
    const { wevos } = entities;
    if (isNil(wevos)) {
        return null;
    }
    const wevo = wevos[wevoId];
    if (!wevo) return null;
    const audiences = wevo.audiences;
    return audiences
        ? audiences.reduce((acc, wevoAudienceId) => {
              const wevoAudience = audienceSelectors.getWevoAudience(
                  entities,
                  wevoAudienceId
              );
              if (wevoAudience) {
                  acc.push(wevoAudience);
              }
              return acc;
          }, [])
        : null;
}

/***************
 // SELECTOR FOR DASHBOARD WEVOS, THE SPECIFIC QUERY SUBSLICE
 // will refactor the names for this specifically later
 ****************/
function getSelectedBoard(state, props) {
    const selectedBoardId = getBoardId(state.queryString.status);
    const board = state.boards[selectedBoardId];
    if (board === undefined || board.items === undefined) {
        return null;
    }
    return board.items;
}

export const getSelectedBoardState = createSelector(
    [getSelectedBoard],
    selectedBoard => selectedBoard
);

/***************
 // SELECTOR FOR WEVO ENTITIES
 ****************/
function getWevos(state) {
    const wevos = state.entities.wevos;
    return wevos === undefined ? null : wevos;
}

export const getWevosState = createSelector([getWevos], wevos => wevos);

const WEVO_ACTIONS_BY_STATUS = {
    draft: "edit",
    running: "details",
    pending: "details",
    completed: "results",
    archived: "results"
};
export const getSimpleWevos = createSelector(
    [getSelectedBoardState, getWevosState],
    (selectedBoard, wevos) => {
        if (isNil(selectedBoard) || isNil(wevos)) {
            return [];
        }

        return selectedBoard.map(wevoId => {
            const {
                id,
                name,
                ownerTeamId,
                dateModified,
                status,
                devices,
                dateCompleted,
                datePublished,
                isArchived,
                isDeleted
            } = wevos[wevoId];
            return {
                id: id,
                teamId: ownerTeamId,
                name: name,
                status: status,
                updated: dateModified,
                action: WEVO_ACTIONS_BY_STATUS[status],
                completed: dateCompleted,
                published: datePublished,
                devices: devices,
                isArchived,
                isDeleted
            };
        });
    }
);



// WEBPACK FOOTER //
// ./src/modules/wevos/selectors.js